import { vaultPostRequest } from '../helpers';
import type { IMoveCropRequest } from './move-crop-request';
import type { IMoveCropResponse } from './move-crop-response';
import { moveCropResponseSchema } from './move-crop-response';

export async function moveCropApi(body: IMoveCropRequest): Promise<IMoveCropResponse> {
  return vaultPostRequest({ path: '/crop/move', body, schema: moveCropResponseSchema });
}
